const { formatText } = require("core/i18n").i18n;
// @helpers
const {
    DEFAULT_TRANSLATION_TEXT,
    DEFAULT_TRANSLATION_TEXT_MISSING_VALUE,
} = require("constants/translations");

const {
    HISTORY_TYPE_TEST,
    DEFAULT_REASON,
    QUESTION_TYPE_ACCORDION,
    QUESTION_TYPE_TEXT,
} = require('mifid/constants/constants');

const isValidTranslation = (key) => {
    const translation = formatText(key);
    return translation !== DEFAULT_TRANSLATION_TEXT && translation !== DEFAULT_TRANSLATION_TEXT_MISSING_VALUE;
}

const cleanMissingTranslations = (key) => {
    const translation = formatText(key);
    const isTranslationExist = translation === DEFAULT_TRANSLATION_TEXT || translation === DEFAULT_TRANSLATION_TEXT_MISSING_VALUE
    return isTranslationExist ? null : translation;
};

const buildTag = (phrase) => {
   return phrase && phrase.split(' ').slice(0,8).join(' ').replace(/[^\w]$/,'')
}


const buildAnswersWithTag = (answersArray, inputType) => {
    const noAnswerSelected = !answersArray.some(ans => ans.selected === "S");
    if (inputType === QUESTION_TYPE_TEXT && answersArray.length === 0) {
        return [{
            selected: "",
            description:"",
            answerTag: buildTag('text answer'),
        }]
    }
    return answersArray.map((ans, index) => {
        if (inputType === QUESTION_TYPE_ACCORDION && noAnswerSelected) {
            return {
                ...ans,
                selected: index === answersArray.length - 1 ? "S" : "N",
                answerTag: buildTag(ans.description),
            }
        }
        return {
            ...ans,
            answerTag: buildTag(ans.description),
        }
    });
};

const buildCategoryName = (questionCategory, isAlternativeFundsTest) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestCategoryName_alternativeFunds_${questionCategory}`
        );
    }
    return cleanMissingTranslations(
        `broker-convenienceMifidTestCategoryName_${questionCategory}`
    );
};

const buildCategoryIcon = (questionCategoryIcon, isAlternativeFundsTest) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestCategoryIcon_alternativeFunds_${questionCategoryIcon}`
        );
    }
    return cleanMissingTranslations(
        `broker-convenienceMifidTestCategoryIcon_${questionCategoryIcon}`
    );
};

const buildSubCategoryName = (questionCategory, questionSubCategory,isAlternativeFundsTest, isV3Test) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestSubCategoryName_alternativeFunds_${questionCategory}_${questionSubCategory}`
        );
    }
    return isV3Test
        ? cleanMissingTranslations(
            `broker-convenienceMifidTestV3SubCategoryName_${questionCategory}_${questionSubCategory}`
        ) : cleanMissingTranslations(
            `broker-convenienceMifidTestSubCategoryName_${questionCategory}_${questionSubCategory}`
        );
};

const buildSubCategoryTitle = (questionCategory, questionSubCategory, isAlternativeFundsTest, isV3Test) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestSubCategoryTitle_alternativeFunds_${questionCategory}_${questionSubCategory}`
        );
    }
    return isV3Test
        ? cleanMissingTranslations(
            `broker-convenienceMifidTestV3SubCategoryTitle_${questionCategory}_${questionSubCategory}`
        ) :  cleanMissingTranslations(
            `broker-convenienceMifidTestSubCategoryTitle_${questionCategory}_${questionSubCategory}`
        );
};

const buildSubCategoryDescription = (questionCategory, questionSubCategory, isAlternativeFundsTest, isV3Test) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestSubCategoryDescription_alternativeFunds_${questionCategory}_${questionSubCategory}`
        );
    }
    return isV3Test
        ? cleanMissingTranslations(
            `broker-convenienceMifidTestV3SubCategoryDescription_alternativeFunds_${questionCategory}_${questionSubCategory}`
        ) :  cleanMissingTranslations(
            `broker-convenienceMifidTestSubCategoryDescription_${questionCategory}_${questionSubCategory}`
        );
};

const buildSectionName = (
    questionSection,
    questionCategory,
    questionSubCategory,
    isAlternativeFundsTest,
    isV3Test,
) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestSectionName_alternativeFunds_${questionCategory}_${questionSubCategory}_${questionSection}`
        );
    }
    return isV3Test
        ? cleanMissingTranslations(
            `broker-convenienceMifidTestV3SectionName_${questionCategory}_${questionSubCategory}_${questionSection}`
        ) : cleanMissingTranslations(
            `broker-convenienceMifidTestSectionName_${questionCategory}_${questionSubCategory}_${questionSection}`
        );
};

const buildQuestionIcon = (
    questionId,
    questionSection,
    questionCategory,
    questionSubCategory,
    isAlternativeFundsTest,
    isV3Test,
) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionIcon_alternativeFunds_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
    }
    return isV3Test
        ? cleanMissingTranslations(
            `broker-convenienceMifidTestV3QuestionIcon_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        ) : cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionIcon_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
};

const buildQuestionInformation = (
    questionId,
    questionSection,
    questionCategory,
    questionSubCategory,
    isAlternativeFundsTest,
    isV3Test,
) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionDescription_alternativeFunds_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
    }
    return isV3Test
        ? cleanMissingTranslations(
            `broker-convenienceMifidTestV3QuestionDescription_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        ) : cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionDescription_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
};

const buildQuestionDisclaimer = (
    questionId,
    questionSection,
    questionCategory,
    questionSubCategory,
    isAlternativeFundsTest,
    isV3Test,
) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionDisclaimer_alternativeFunds_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
    }
    return isV3Test
        ? cleanMissingTranslations(
            `broker-convenienceMifidTestV3QuestionDisclaimer_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        ) : cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionDisclaimer_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
};

const buildQuestionSecondDisclaimer = (
    questionId,
    questionSection,
    questionCategory,
    questionSubCategory,
    isAlternativeFundsTest
) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionSecondDisclaimer_alternativeFunds_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
    }
    return cleanMissingTranslations(
        `broker-convenienceMifidTestQuestionSecondDisclaimer_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
    );
};

const buildQuestionLabel = (
    questionId,
    questionSection,
    questionCategory,
    questionSubCategory,
    isAlternativeFundsTest
) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionLabel_alternativeFunds_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
    }
    return cleanMissingTranslations(
        `broker-convenienceMifidTestQuestionLabel_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
    );
};

const buildQuestionFootstep = (
    questionId,
    questionSection,
    questionCategory,
    questionSubCategory,
    isAlternativeFundsTest
) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionFootstep_alternativeFunds_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
    }
    return cleanMissingTranslations(
        `broker-convenienceMifidTestQuestionFootstep_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
    );
};

const buildInvalidAnswerText = (
    questionId,
    questionSection,
    questionCategory,
    questionSubCategory,
    isAlternativeFundsTest
) => {
    if (isAlternativeFundsTest) {
        return cleanMissingTranslations(
            `broker-convenienceMifidTestQuestionError_alternativeFunds_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
        );
    }
    return cleanMissingTranslations(
        `broker-convenienceMifidTestQuestionError_${questionCategory}_${questionSubCategory}_${questionSection}_${questionId}`
    );
};


const getTypeTest = (typeTest) => {
    const listTypeTest = {
        1: formatText('consultMiFID-noncomplexProducts'),
        2: formatText('consultMiFID-fundsProduct'),
        3: formatText('consultMiFID-rightProduct'),
        4: formatText('consultMiFID-ETFProduct'),
        5: formatText('consultMiFID-warrantsProduct'),
        6: formatText('consultMiFID-especiallyComplexProducts'),

    }

    return listTypeTest[typeTest];
}

const getReason = (reason) => {
    const listReason = {
        0: formatText('consultMiFID-pendingEvaluationStatus'),
        1: formatText('consultMiFID-notConvenientStatus'),
        2: formatText('consultMiFID-expiredStatus'),
        3: formatText('consultMiFID-convenientStatus'),
        4: formatText('consultMiFID-pendingEvaluationStatus'),
    }

    return listReason[reason]
}

const buildItems = (listItems) => {
    const initialListTest = HISTORY_TYPE_TEST;
    initialListTest.map((item, index) => {
        const itemTest = listItems.find(test => test.tipoTest === item.TYPE_TEST);
        if(itemTest) {
                initialListTest[index].DATE = itemTest.dateTest;
                initialListTest[index].STATUS = getReason(itemTest.reason)
                initialListTest[index].DESCRIPTION_TEST = getTypeTest(itemTest.tipoTest)
        } else {
                initialListTest[index].STATUS = getReason(DEFAULT_REASON);
                initialListTest[index].DESCRIPTION_TEST = getTypeTest(item.TYPE_TEST)
        }
    })
    return initialListTest;
}

const buildTestScoreInfo = (reason) => {
    if (reason.toString() === '1') {
        return formatText('broker-convenienceMifidTestResultReason1');
    } else if (reason.toString() === '3'){
        return formatText('broker-convenienceMifidTestResultReason3');
    } else {
        return '-';
    }
}

const buildTestScoreInfoForAltFunds = (result) => {
    if (result === 'A') {
        return formatText('broker-convenienceMifidTestResultA');
    } else {
        return formatText('broker-convenienceMifidTestResultR');
    }
}



module.exports = {
    isValidTranslation,
    buildCategoryName,
    buildCategoryIcon,
    buildItems,
    buildSubCategoryName,
    buildSubCategoryTitle,
    buildSubCategoryDescription,
    buildSectionName,
    buildQuestionIcon,
    buildQuestionInformation,
    getReason,
    buildTag,
    buildAnswersWithTag,
    buildTestScoreInfo,
    buildQuestionDisclaimer,
    buildQuestionSecondDisclaimer,
    buildQuestionLabel,
    buildQuestionFootstep,
    buildInvalidAnswerText,
    buildTestScoreInfoForAltFunds,
};
